import React, { useEffect, useState } from "react";
import { FaPlus, FaUserDoctor } from "react-icons/fa6";
import DoctorModal from "../../Modal/DoctorModal/DoctorModal";
import { useDispatch, useSelector } from "react-redux";
import {
  getDcotorAction,
  updateDcotorAction,
} from "../../Actions/DoctorAction/DoctorAction";
import { MdEdit } from "react-icons/md";
import { RxUpdate } from "react-icons/rx";
import { IoClose } from "react-icons/io5";
import LoadingPage from "../Loading/LoadingPage";

const Doctor = () => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const getDoctor = useSelector((state) => state.getDoctor);
  const { doctors, loading } = getDoctor;
  const dispatch = useDispatch();
  const [doctorName, setDoctorName] = useState(null);
  const [indexx, setIndexx] = useState(null);
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);

  const [debouncedValue, setDebouncedValue] = useState('');

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(doctorName);
    }, 1000); 
    return () => {
      clearTimeout(handler);
    };
  }, [doctorName]);
  const [inputValue, setInputValue] = useState({
    doctor_id: "",
    name: "",
    status: "",
  });
  useEffect(() => {
    if(debouncedValue!=null){
      dispatch(getDcotorAction(null,debouncedValue));

    }
  }, [debouncedValue]);

  const handleEdit = (id, name, status, index) => {
    setInputValue({
      ...inputValue,
      name: name,
      status: status,
      doctor_id: id,
    });
    setIndexx(index);
    setIsOpenUpdate(true);
  };
  const handleClose = () => {
    setIndexx(null);
    setIsOpenUpdate(false);
  };
  const handleUpdate = () => {
    dispatch(
      updateDcotorAction(
        inputValue.doctor_id,
        inputValue.name,
        inputValue.status
      )
    );
    setIndexx(null);
    setIsOpenUpdate(false);
  };
  return (
    <>
      {loading ? (
        <LoadingPage />
      ) : (
        <div className="parent">
          <div className="flex justify-between gap-2 px-2 items-center">
            <div className="flex gap-1 items-center font-bold text-blue-600">
              <FaUserDoctor />
              <p>Doctors</p>
            </div>
            <div className="mt-1">
              <button
                className="btn-primary flex gap-2 items-center"
                onClick={() => setIsOpenModal(true)}
              >
                <p>Add</p>
                <FaPlus />
              </button>
            </div>
          </div>
          <div className="m-auto w-11/12">
            <input
              type="text"
              onChange={(e) => setDoctorName(e.target.value)}
              value={doctorName}
              className=" m-auto mt-3 input"
              placeholder="Search By Doctor Name"
            />
          </div>
          <div className="parent-table">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Doctor</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {doctors?.map((doctor, index) => {
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        {indexx == index && isOpenUpdate ? (
                          <input
                            type="text"
                            className="input w-full"
                            placeholder="Name"
                            onChange={(e) => {
                              setInputValue({
                                ...inputValue,
                                name: e.target.value,
                              });
                            }}
                            value={inputValue.name}
                          />
                        ) : (
                          doctor.name
                        )}
                      </td>
                      {index == indexx && isOpenUpdate ? (
                        <td>
                          <select
                            name=""
                            onChange={(e) => {
                              setInputValue({
                                ...inputValue,
                                status: e.target.value,
                              });
                            }}
                            value={inputValue.status}
                            id=""
                            className="input w-full"
                          >
                            <option value="1">Active</option>
                            <option value="0">Deactive</option>
                          </select>
                        </td>
                      ) : (
                        <td>
                          {doctor.status == 1 ? (
                            <div className="bg-teal-500 text-center lg:w-[27%] text-gray-100 px-4 py-1">
                              Active
                            </div>
                          ) : (
                            <div className="bg-red-500 text-center lg:w-[27%] text-gray-100 px-4 py-1">
                              Deactive
                            </div>
                          )}
                        </td>
                      )}

                      <td>
                        {indexx == index && isOpenUpdate ? (
                          <div className="flex gap-2  items-center">
                            <button
                              onClick={handleUpdate}
                              className="btn-primary flex gap-2 items-center"
                            >
                              Update <RxUpdate />
                            </button>
                            <button
                              onClick={handleClose}
                              className="btn-danger flex gap-2 items-center"
                            >
                              Close <IoClose />{" "}
                            </button>
                          </div>
                        ) : (
                          <button
                            onClick={() => {
                              handleEdit(
                                doctor.id,
                                doctor.name,
                                doctor.status,
                                index
                              );
                            }}
                            className="btn-warning   flex items-center gap-2"
                          >
                            Edit <MdEdit />
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {isOpenModal && (
            <DoctorModal closeModal={() => setIsOpenModal(false)} />
          )}
          <div className="pb-10"></div>
        </div>
      )}
    </>
  );
};

export default Doctor;
